import React from 'react'
import { Avatar, Stack } from '@mui/material'
import { useAppDispatch } from '../redux/hooks'
import { setVideoPlayer } from '../redux/reducers/modal-player/modal-player.actions'
import { Workout } from '../models/interfaces/workout.interface'
import { WorkoutProps } from '../pages/Workouts'
import Iconify from './Iconify'

type Props = {
  data: Workout | WorkoutProps
  onPress?: () => void
}

export function Thumbnail ({ data }: Props) {
  const dispatch = useAppDispatch()
  const handleSetPlayer = () => {
    dispatch(setVideoPlayer({
      video: {
        videoUrl: data.videoUrl,
        name: data.name,
        id: data.id
      },
      isVisible: true
    }))
  }
  return (
    <Stack alignItems="center">
      <Stack width="100%" justifyContent="center" alignItems="center">
        <Stack onClick={handleSetPlayer} sx={{ cursor: 'pointer' }}>
          <Avatar
            sx={{ bgcolor: 'rgb(250, 89, 62, 0.1)', width: 90, height: 90, borderRadius: 1 }}
            src={data?.thumbUrl}
          >&nbsp;
          </Avatar>
          <Stack position="relative" sx={{ width: 90, height: 90, justifyContent: 'center', alignItems: 'center', marginTop: -11.5 }}>
            <Avatar sx={{ bgcolor: 'rgba(214, 83, 52, 0.7)' }}>
              <Iconify color='rgba(255, 255, 255, 0.8)' icon="ph:play-fill" width="18px"></Iconify>
            </Avatar>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  )
}
